import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IshodiucenjaPopisService } from './ishodiucenja-popis.service';
import { IshodiucenjaPopis } from './ishodiucenja-popis';
import { Subject } from 'rxjs';
import * as toastr from 'toastr';
import * as alertify from 'alertify.js';

@Component({
  selector: 'app-ishodiucenja-popis',
  templateUrl: './ishodiucenja-popis.component.html',
  styleUrls: ['./ishodiucenja-popis.component.css'],
  providers: [ IshodiucenjaPopisService ]
})
export class IshodiUcenjaComponent implements OnInit {

  sviIshodiucenja: IshodiucenjaPopis[] = [];
  ishodiucenjaOptions: DataTables.Settings = {};
  ishodiucenjaTrigger: Subject<IshodiucenjaPopis> = new Subject();

  ishodiucenjaForma: FormGroup;
  ishodiucenjaEditForma: FormGroup;

  svapodrucjaznanja: any = [];
  svevrsteuvjerenja: any = [];

  constructor(
    private _fb: FormBuilder,
    private _ishodiucenjaPopisService: IshodiucenjaPopisService
  ) { }

  ngOnInit() {
    this.dohvatiKompetencije();
    this.dohvatiSvaAktivnaPodrucjaznanja();
    this.dohvatiSveVrsteuvjerenja();
    //Tablica početak
    this.ishodiucenjaOptions = {
      pagingType: 'full_numbers',
      pageLength: 50,
      responsive: true,
      columnDefs: [{
          targets: 'no-sort',
          orderable: false
      }],
      retrieve: true
    };
    //Tablica kraj
    this.ishodiucenjaForma = this._fb.group({
      naziv: [''],
      podrucjeZnanja: [''],
      vrstaUvjerenja: ['']
    });
    this.ishodiucenjaEditForma = this._fb.group({
      id:[''],
      naziv: [''],
      podrucjeZnanja: [''],
      vrstaUvjerenja: ['']
    });
  }

  dohvatiSvaAktivnaPodrucjaznanja(){
    this._ishodiucenjaPopisService.dohvatiAktivnaPodrucjaznanja({'idkorisnik': localStorage.getItem('userId')}).subscribe(res=>{
      //console.log(res);
      if (res.success == true) {
        this.svapodrucjaznanja = res.data[0];
      } else {
        this.svapodrucjaznanja = [];
      }
    })
  }

  dohvatiSveVrsteuvjerenja(){
    this._ishodiucenjaPopisService.dohvatiVrsteuvjerenja({'idkorisnik': localStorage.getItem('userId')}).subscribe(res=>{
      //console.log(res);
      if (res.success == true) {
        this.svevrsteuvjerenja = res.data;
      } else {
        this.svevrsteuvjerenja = [];
      }
    })
  }

  pripremiPodatke(ishod){
    //console.log(ishod);
    this.ishodiucenjaEditForma = this._fb.group({
      id: ishod['id'],
      naziv: ishod['naziv'],
      podrucjeZnanja: ishod['idpodrucjeznanja'],
      vrstaUvjerenja: ishod['idvrstauvjerenja']
    });
  }

  uredi(ishod){
    //console.log(ishod);
    let objektZaSlanje = {
      'idishodiucenja': ishod['id'],
      'naziv': ishod['naziv'],
      'idpodrucjeznanja': ishod['podrucjeZnanja'],
      'idvrstauvjerenja': ishod['vrstaUvjerenja']
    }
    //console.log(objektZaSlanje);
    this._ishodiucenjaPopisService.urediKompetenciju(objektZaSlanje).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        toastr.success("Uspješno uređivanje!");
        this.dohvatiKompetencije();
      } else {
        toastr.error("Neuspješno uređivanje!");
      }
    });
  }

  obrisiIshoducenja(ishod){
    //console.log(ishod);
    let ovo = this;
    alertify
    .okBtn("Obriši")
    .cancelBtn("Odustani")
    .confirm("Jeste li sigurni da želite obrisati kompetenciju?", function (ev) {
      ev.preventDefault();
      if (alertify.success){
        ovo._ishodiucenjaPopisService.obrisiKompetenciju({'idishodiucenja': ishod.id}).subscribe(res => {
          //console.log(res);
          if(res.success == true){
            toastr.success("Uspješno obrisana kompetencija!");
            ovo.dohvatiKompetencije();
          } else {
            toastr.error(res.message);
          }
        })
      }
    }, function(ev) {
      ev.preventDefault();
      toastr.info('Odustali ste od brisanja kompetencije.');
    });
  }

  spremiIshoducenja(ishodiucenjaForma){
    //console.log(ishodiucenjaForma);
    let objektZaSlanje = {
      'naziv': ishodiucenjaForma['naziv'],
      'idpodrucjeznanja': ishodiucenjaForma.podrucjeZnanja,
      'idvrstauvjerenja': ishodiucenjaForma.vrstaUvjerenja,
    };
    //console.log(objektZaSlanje);
    if(ishodiucenjaForma['naziv'] && ishodiucenjaForma['podrucjeZnanja'] && ishodiucenjaForma['vrstaUvjerenja']){
      this._ishodiucenjaPopisService.spremiKompetenciju(objektZaSlanje).subscribe(res => {
        if(res.success == true){
          toastr.success("Uspješno dodana kompetencija!");
          $('#ishodiucenjaTablica').DataTable().destroy();
          this.dohvatiKompetencije();
        } else {
          toastr.error("Neuspješno spremanje!");
        }
      });
    } else {
      toastr.error("Unesite potrebne podatke!");
    }
  }

  dohvatiKompetencije(){
    this.sviIshodiucenja = [];
    this._ishodiucenjaPopisService.dohvatiSve({'idkorisnik': localStorage.getItem('userId')}).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        for(let i = 0; i < res.data.length; i++){
          this.sviIshodiucenja.push({
            'id': res.data[i]['idishodiucenja'],
            'naziv': res.data[i]['iu_tekst'],
            'idvrstauvjerenja': res.data[i]['vrstauvjerenja_idvrstauvjerenja'],
            'vrstauvjerenja': res.data[i]['vrstauvjerenjanaziv'],
            'idpodrucjeznanja': res.data[i]['podrucjeznanja_idpodrucjeznanja'],
            'podrucjeznanja': res.data[i]['podrucjeznanjanaziv']
          });
        }
        this.ishodiucenjaTrigger.next();
      } else {
        toastr.error("Neuspješno dohvaćanje!");
      }
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/ishodiucenja-popis/ishodiucenja-popis.component.ts